import { z } from "zod";
export const CalendarSubscriptionQuerySchema = z.object({ managerId: z.string().uuid() }).strict();
export const CalendarSubscriptionMutationSchema = CalendarSubscriptionQuerySchema.extend({
    action: z.enum(["enable", "rotate", "revoke"]),
    expectedVersion: z.number().int().min(0),
    idempotencyKey: z.string().min(16).max(160),
}).strict();
export const CalendarSubscriptionStateSchema = z.object({
    managerId: z.string().uuid(),
    managerName: z.string(),
    active: z.boolean(),
    version: z.number().int().min(0),
    feedPath: z.string().regex(/^\/api\/calendar\/feeds\/[0-9a-f-]{36}\/[A-Za-z0-9_-]{43}\.ics$/u).nullable(),
});
//# sourceMappingURL=calendar-subscriptions.js.map